import miment from "miment";
export default {
  getDuration(date1, date2) {
    const distance = miment()
      .distance(date1, date2)
      .format("YYYY-MM-DD", true);
    const ymd = distance.split("-").map(item => parseInt(item));
    let year = ymd[0];
    let month = ymd[1];
    let date = ymd[2];
    // 大概计算，因为每个月天数不同，取最小的算 28
    // 如果日单位超过25日，则视为 达到1个月的单位，月单位进1
    if (month > 0 && date >= 28) {
      date = 0;
      month += 1;
    }
    if (month === 12) {
      month = 0;
      year += 1;
    }
    let duration = "";
    if (year > 0) {
      duration += year + " 年";
    }
    if (month > 0) {
      duration += month + " 月";
    }
    if (date > 0) {
      duration += date + " 日";
    }
    return duration;
  },
  getAge(date) {
    const distanceYear = miment()
      .distance(date)
      .format("YYYY", true);
    return parseInt(distanceYear);
  },
  getBirthdayByID(id) {
    const year = id.substr(6, 4);
    const month = id.substr(10, 2);
    const date = id.substr(12, 2);
    return year + "-" + month + "-" + date;
  },
  getIdBySex(id) {
    return id.charAt(id.length - 2) % 2 ? "1" : "2";
  }
};
